import { lazy } from 'react';

export const SendCoin = lazy(() => import('./SendCoin.component'));
